import { EXPRESS_API } from 'configs/api/expressApi';
import {
  AttributeListItem,
  CreateParams,
  QueryListParams,
  VideoListItem,
} from '.';

export const getAttributes = async ({
  page = 0,
  size = 10,
  search,
  sort,
  filterByDepartment = false,
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search: search,
    sort: sort,
    filterByDepartment,
  };

  const { data } = await EXPRESS_API.get('/video-attributes', {
    params,
  });

  const { videoAttributes = [], count = 0 } = data || {};

  return { count, attributes: videoAttributes as VideoListItem };
};

export const getAttribute = async (id: number) => {
  const response = await EXPRESS_API.get(`/video-attributes/${id}`);

  return response.data;
};

export const getAttributeValueDetailsMetric = async (
  id: string,
  value: string,
  {
    page = 0,
    size = 10,
    sort,
    startDate,
    endDate,
    department,
    user,
    search,
    videoType,
  }: any
) => {
  const response = await EXPRESS_API.get(
    `metrics/reports/video-attributes-details/${id}/value`,
    {
      params: {
        value,
        start: page * size,
        limit: size,
        sort,
        from: startDate,
        to: endDate,
        department,
        user,
        search,
        videoType,
      },
    }
  );

  return response.data;
};

export const getAttributeValueMetrics = async (id: string, params?: any) => {
  const response = await EXPRESS_API.get(
    `metrics/reports/video-attributes-details/${id}`,
    { params }
  );

  return response.data;
};

export const getAttributeValueRecord = async (id: string) => {
  const response = await EXPRESS_API.get(`video-attributes/value/${id}`);

  return response.data;
};

export const createAttribute = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/video-attributes', data);

  return response.data;
};

export const updateAttribute = async (data: AttributeListItem) => {
  const response = await EXPRESS_API.put(
    `/video-attributes/${data.attributeId}`,
    data
  );

  return response.data;
};

export const deleteAttribute = async (attributeId: string) => {
  await EXPRESS_API.delete(`/video-attributes/${attributeId}`);

  return { attributeId };
};

export const updateOrderAttributes = async (data: AttributeListItem[]) => {
  const response = await EXPRESS_API.put('/video-attributes', data);

  return response.data;
};

export const getVideoAttributes = async ({ videoId }: any) => {
  const { data } = await EXPRESS_API.get(`/videos/${videoId}/video-attributes`);
  const { videoAttributes = [] } = data || {};

  return { videoAttributes } as { videoAttributes: VideoListItem };
};

export const putVideoAttributes = async (videoId: string, data: object[]) => {
  const { data: videoAttributes } = await EXPRESS_API.put(
    `/videos/${videoId}/video-attributes`,
    data
  );

  return { videoAttributes };
};
